'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateApp = undefined;

var _validateProperty = require('ui-addon-upgrades/_core/common/data/upgradeData/validators/validateProperty');

var validateApp = exports.validateApp = function validateApp(app) {
  var isValidApp = typeof app === 'string' && app.length > 0;

  return (0, _validateProperty.validateProperty)(isValidApp, 'expected app to be a non-empty string but got ' + app, 'app');
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/data/upgradeData/validators/validateApp.js
// module id = 441
// module chunks = 3 4 5